module.exports = __webpack_public_path__ + "static/media/spiderman.b7b9ed2c.gif";